export default __webpack_public_path__ + "static/media/gallery_32.a863a17b.jpg";